export default {
  'wallet.add-blacklist': 'Add Blacklist',
  'wallet.add-currency': 'Add Currency',
  'wallet.add-external-account': 'Add External Account',
  'wallet.add-webhook': 'Add Webhook',
  'wallet.adjust': 'Adjust',
  'wallet.apply-recharge': 'Apply Recharge',
  'wallet.approve': 'Approve',
  'wallet.cancel': 'Cancel',
  'wallet.change-password': 'Change Password',
  'wallet.check-limit': 'Check Limit',
  'wallet.confirm-adjust': 'Confirm Adjust',
  'wallet.confirm-consume': 'Confirm Consume',
  'wallet.confirm-delete-account': 'Confirm Delete Account',
  'wallet.confirm-delete-blacklist': 'Confirm Delete Blacklist',
  'wallet.confirm-delete-credential': 'Confirm Delete Credential',
  'wallet.confirm-delete-rule': 'Confirm Delete Rule',
  'wallet.confirm-delete-webhook': 'Confirm Delete Webhook',
  'wallet.confirm-recharge': 'Confirm Recharge',
  'wallet.confirm-withdraw': 'Confirm Withdraw',
  'wallet.create-batch': 'Create Batch',
  'wallet.create-credential': 'Create Credential',
  'wallet.create-reconciliation-batch': 'Create Reconciliation Batch',
  'wallet.create-reversal': 'Create Reversal',
  'wallet.create-risk-rule': 'Create Risk Rule',
  'wallet.create-rule': 'Create Rule',
  'wallet.create-sub-account': 'Create Sub Account',
  'wallet.create-wallet': 'Create Wallet',
  'wallet.delete': 'Delete',
  'wallet.detail': 'Detail',
  'wallet.disable-mfa': 'Disable MFA',
  'wallet.edit': 'Edit',
  'wallet.edit-credential': 'Edit Credential',
  'wallet.enable-mfa': 'Enable MFA',
  'wallet.execute': 'Execute',
  'wallet.export': 'Export',
  'wallet.extend': 'Extend',
  'wallet.fee-calculator': 'Fee Calculator',
  'wallet.freeze': 'Freeze',
  'wallet.handle-expiry': 'Handle Expiry',
  'wallet.ignore': 'Ignore',
  'wallet.init-config': 'Init Config',
  'wallet.query': 'Query',
  'wallet.refresh-expiring': 'Refresh Expiring',
  'wallet.reject': 'Reject',
  'wallet.reset': 'Reset',
  'wallet.save': 'Save',
  'wallet.saved': 'Saved',
  'wallet.set-default': 'Set Default',
  'wallet.set-limit': 'Set Limit',
  'wallet.set-password': 'Set Password',
  'wallet.test': 'Test',
  'wallet.unfreeze': 'Unfreeze',
  'wallet.verify': 'Verify',
  'wallet.view-detail': 'View Detail',
  'wallet.not-found.title': 'Wallet Not Activated',
  'wallet.not-found.description':
    'Initializing your wallet, please refresh and try again',
  'wallet.not-found.retry': 'Retry',
  'wallet.create-account': 'Create Account',
  'wallet.create-account-success': 'Account created successfully',
  'wallet.create-account-failed': 'Failed to create account',
  'wallet.my-accounts': 'My Accounts',
  'wallet.recent-transactions': 'Recent Transactions',
  'wallet.currency-code': 'Currency',
  'wallet.currency-code-required': 'Please enter currency code',
  'wallet.fund-type': 'Fund Type',
  'wallet.fund-type-required': 'Please select fund type',
};
